import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from "./router";
import VueCookies from 'vue-cookies'
import metaInfo from 'vue-meta-info'
import { createApp } from 'vue'

// 分页组件
import Pagination from "@/components/Pagination";

import '@/assets/index.css'

// 全局组件挂载
Vue.component('Pagination', Pagination)

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueCookies)

Vue.use(metaInfo)

// const app = createApp(App)
// // 设置全局变量
// app.config.globalProperties.$tel = '18500898867'
// app.config.globalProperties.$email = '337832363@qq.com'
// app.config.globalProperties.$wx = '@assets/weixin.jpg'

Vue.prototype.$tel = '18500898867'
Vue.prototype.$email = '337832363@qq.com'
Vue.prototype.$wx = '@/assets/weixin.jpg'

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
